export default __webpack_public_path__ + "static/media/prof_walid_salameh.d93cf7cc.jfif";